var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.dataavailable)?_c('p',{staticStyle:{"font-size":"2rem","margin-top":"40vh"}},[_vm._v("无需处理的数据NO DATA")]):_vm._e(),_vm._v(" "),_vm._l((_vm.collections),function(x){return _c('div',{key:x.label},[_c('approval',{attrs:{"tabletitle":x.label,"collection":x.value},on:{"hasdata":function($event){_vm.dataavailable=true}}})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f91b90e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/received/received.vue
// module id = null
// module chunks = 